const T_PREFIX = "cookie-popup";

export const cookiePopupTrns = {
  title: `${T_PREFIX}.title`,
  description: `${T_PREFIX}.description`,

  readMoreButton: `${T_PREFIX}.read-more-btn`,
  understandButton: `${T_PREFIX}.understand-btn`,
};
